<script>
	import {
		checkLogin
	} from "./libs/login";
	import {
		HTTP_REQUEST_URL,
		TOKENNAME
	} from './config/app';
	// #ifdef H5
	import Auth from './libs/wechat.js';
	// #endif
	import Routine from './libs/routine.js';
	import Apps from './libs/apps.js';
	import Cache from './utils/cache.js';
	import {
		getTheme,
		loginConfigApi,
		tokenIsExistApi,
		getTemlIds
	} from './api/api.js';
	import {
		mapActions
	} from 'vuex'
	import {
		spread
	} from "@/api/user";
	import { getCntMsg } from '@/api/message.js';
	import { markCsRead } from '@/api/cs-op.js';
	import { uploadDeviceCode } from '@/api/api.js';
	import pages from '/pages.json';
	// #ifdef APP-PLUS
	import {
		registerRequestPermissionTipsListener,
		unregisterRequestPermissionTipsListener,
		setRequestPermissionTips
	} from "@/uni_modules/uni-registerRequestPermissionTips"
	var PermissionTips = {}
	PermissionTips["android.permission.CAMERA"] =
		"<h4 style=\"font-size:40px;\">相机权限使用说明</h4><font>用于拍摄、录制视频，更换用户头像，发表商品评论和社区圈子等场景</font>";
	PermissionTips["android.permission.READ_EXTERNAL_STORAGE"] =
		"<h4 style=\"font-size:40px;\">读取相册权限使用说明</h4><font>用于更换用户头像，发表商品评论和社区圈子等场景</font>";
	PermissionTips["android.permission.WRITE_EXTERNAL_STORAGE"] =
		"<h4 style=\"font-size:40px;\">读取相册权限使用说明</h4><font>用于更换用户头像，发表商品评论和社区圈子等场景</font>";
	PermissionTips["android.permission.READ_MEDIA_IMAGES"] =
		"<h4 style=\"font-size:40px;\">读取相册权限使用说明</h4><font>用于更换用户头像，发表商品评论和社区圈子等场景</font>";
	PermissionTips["android.permission.READ_MEDIA_VIDEO"] =
		"<h4 style=\"font-size:40px;\">读取相册权限使用说明</h4><font>用于更换用户头像，发表商品评论和社区圈子等场景</font>";
	PermissionTips["android.permission.ACCESS_FINE_LOCATION"] =
		"<h4 style=\"font-size:40px;\">精确定位权限使用说明</h4><font>用于定位用户位置，快速填写用户商品收货地址等场景</font>";
	PermissionTips["android.permission.ACCESS_COARSE_LOCATION"] =
		"<h4 style=\"font-size:40px;\">粗略定位权限使用说明</h4><font>用于定位用户位置，快速填写用户商品收货地址等场景</font>";
	// #endif

	var statusBarHeight = uni.getSystemInfoSync().statusBarHeight; //手机端头部手机时间位置高度

	export default {
		globalData: {
			statusBarHeight: statusBarHeight, //手机端头部手机时间位置高度
			spread: 0, //推广人id
			code: 0,
			isLogin: false,
			userInfo: {},
			MyMenus: [],
			windowHeight: 0,
			navHeight: 0,
			navH: 0,
			id: 0, //商品id
			isIframe: false,
			theme: 'theme3', //主题色
			publicLoginType: Cache.get('publicLoginType') ? Cache.get('publicLoginType') : '', //公众号登录方式(单选),1微信授权，2手机号登录
			routinePhoneVerification: '', //小程序手机号校验类型（多选）1微信小程序验证 2短信验证
			companyName: uni.getStorageSync('companyName') ? uni.getStorageSync('companyName') : '欢迎你', //公司名称
			tokenIsExist: false, //登录是否失效 false 失效，true没失效
			mobileLoginLogo: uni.getStorageSync('mobileLoginLogo') ||
				'/static/images/logo-green.png' //登录页logo
		},
		onLaunch: function(option) {
		// #ifdef APP-PLUS || H5
		// 中键弹半屏发布面板（四个tab页挂载publishSheet监听）；再点中键=关闭（原生tabBar在蒙层之上仍可点击）
		let midSheetOpen = false;
		uni.$on('publish:sheetVisible', (v) => { midSheetOpen = v; });
		uni.onTabBarMidButtonTap(() => {
			uni.$emit(midSheetOpen ? 'publish:closeSheet' : 'publish:openSheet');
		});
		// #endif
			// #ifdef APP-PLUS
			const systemInfo = uni.getSystemInfoSync();
			const brand = systemInfo.deviceBrand;
			const platform = systemInfo.platform;
			if (platform !== "ios") {
				setRequestPermissionTips(PermissionTips)
				registerRequestPermissionTipsListener({
					onRequest: (e) => {
						console.log(e)
					},
					onConfirm: (e) => {
						console.log(e)
					},
					onComplete: (e) => {
						// 华为手机在权限禁止之后，再次申请权限不会出现权限申请框。此时应该引导用户去系统设置开启此权限，不应该频繁申请。
						if (brand.toLowerCase() == "huawei") {
							var tips = {}
							var hasDeniedPermission = false
							for (var k in PermissionTips) {
								if (e[k] != "denied") {
									tips[k] = PermissionTips[k]
								} else {
									hasDeniedPermission = true
								}
							}
							setRequestPermissionTips(tips) // 更新弹框提醒，防止华为手机不出现权限申请框时权限提醒框闪烁的情况
							if (hasDeniedPermission)
								uni.showModal({
									content: "权限已经被拒绝，请前往设置中开启"
								})
						}
					}
				})
			}

			//获取首次授权配置
			this.getFirstAgree();

			// #endif
		// #ifdef APP-PLUS
		// 获取设备的cid
		uni.getPushClientId({
			success: (res) => {
				const oldCid = uni.getStorageSync("cid");
				if (oldCid && oldCid !== res.cid) {
					uni.removeStorageSync("lastUploadCid");
				}
				uni.setStorageSync("cid", res.cid);
				const token = this.$Cache.get('token');
				if (token && res.cid) {
					uploadDeviceCode(res.cid).catch(() => {});
				}
			},
			fail: () => {}
		});
		
		// 监听推送消息
		uni.onPushMessage((res) => {
			this.handlePush(res);
		});
		// #endif
		
		// #ifdef APP-PLUS
		if (uni.getSystemInfoSync().platform === 'android') {
			const osVersion = parseInt(uni.getSystemInfoSync().system.replace('Android ', ''));
			if (osVersion >= 8) {
				const main = plus.android.runtimeMainActivity();
				const nm = main.getSystemService("notification");
				plus.android.importClass(nm);
				const NotificationChannel = plus.android.importClass("android.app.NotificationChannel");
				const ch = new NotificationChannel("PUSH_NOTIFY", "推送通知", 4);
				ch.enableVibration(true);
				nm.createNotificationChannel(ch);
			}
			if (osVersion >= 13) {
				plus.android.requestPermissions(['android.permission.POST_NOTIFICATIONS'], (r) => {}, (e) => {});
			}
		}
		// #endif
		
		//获取登录配置
		this.getLoginConfig();

		//校验token是否有效,true为有效，false为无效
		tokenIsExistApi().then(res => {
			this.globalData.tokenIsExist = res.data;
		})

		this.globalData.tabBarList = pages.tabBar.list;
		let that = this;
		// #ifdef APP-PLUS || H5
		uni.getSystemInfo({
			success: function(res) {
				// 首页没有title获取的整个页面的高度，里面的页面有原生标题要减掉就是视口的高度  
				// 状态栏是动态的可以拿到 标题栏是固定写死的是44px
				let height = res.windowHeight - res.statusBarHeight - 44
				// #ifdef H5 || APP-PLUS
				that.globalData.windowHeight = res.windowHeight + 'px'
				// #endif
			}
		});
		// #endif	
		// #ifdef MP
		const updateManager = uni.getUpdateManager();
		updateManager.onCheckForUpdate(function(res) {
			// 请求完新版本信息的回调
			if (res.hasUpdate) {
				updateManager.onUpdateReady(function(res2) {
					uni.showModal({
						title: '更新提示',
						content: '发现新版本，是否重启应用?',
						cancelColor: '#eeeeee',
						confirmColor: '#FF0000',
						success(res2) {
							if (res2.confirm) {
								// 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
								updateManager.applyUpdate();
							}
						}
					});
				});
			}
		});

		updateManager.onUpdateFailed(function(res) {
			// 新的版本下载失败
			uni.showModal({
				title: '提示',
				content: '检查到有新版本，但下载失败，请检查网络设置',
				success(res) {
					if (res.confirm) {
						// 新的版本已经下载好，调用 applyUpdate 应用新版本并重启
						updateManager.applyUpdate();
					}
				}
			});
		});

		if (HTTP_REQUEST_URL == '') {
			console.error(
				"请配置根目录下的config.js文件中的 'HTTP_REQUEST_URL'\n\n请修改开发者工具中【详情】->【AppID】改为自己的Appid\n\n请前往后台【小程序】->【小程序配置】填写自己的 appId and AppSecret"
			);
			return false;
		}
		//小程序扫码进入场景
		if (option.query.hasOwnProperty('scene')) {
			switch (option.scene) {
				case 1047: //扫描小程序码
				case 1048: //长按图片识别小程序码
				case 1049: //手机相册选取小程序码
				case 1001: //直接进入小程序

					let value = this.$util.getUrlParams(decodeURIComponent(option.query.scene));
					let mapeMpQrCodeValue = this.$util.formatMpQrCodeData(value);
					// that.globalData = mapeMpQrCodeValue;
					that.globalData = Object.assign(that.globalData, mapeMpQrCodeValue);
					that.globalData.spread = mapeMpQrCodeValue.spread ? mapeMpQrCodeValue.spread : '';
					break;
			}
		}
		if (option.spread) that.globalData.spread = option.spread;
		// #endif
		// 获取导航高度；
		uni.getSystemInfo({
			success: function(res) {
				that.globalData.navHeight = res.statusBarHeight * (750 / res.windowWidth) + 91;
			}
		});
		// #ifdef MP
		let menuButtonInfo = uni.getMenuButtonBoundingClientRect();
		that.globalData.navH = menuButtonInfo.top * 2 + menuButtonInfo.height / 2;
		// #endif

		// #ifdef H5	
		if (option.query.hasOwnProperty('type') && option.query.type == "iframeVisualizing") {
			this.globalData.isIframe = true;
		} else {
			this.globalData.isIframe = false;
		}

		// wx公众号自动授权登录
		let snsapiBase = 'snsapi_base';
		let urlData = location.pathname + location.search;
		let isPublicCircleShare = location.pathname.indexOf('/pages/circle/circleDetail') !== -1 &&
			option.query.hasOwnProperty('shareCode');
		//publicLoginType，公众号登录方式(单选),1微信授权，2手机号登录
		if (!that.$store.getters.isLogin && Auth.isWeixin() && this.globalData.publicLoginType == 1 && !that
			.globalData.tokenIsExist && !isPublicCircleShare) {
			const {
				code,
				state,
				scope
			} = option.query;
			if (code && code != uni.getStorageSync('snsapiCode') && location.pathname.indexOf(
					'/pages/users/wechat_login/index') === -1) {
				// 存储静默授权code
				uni.setStorageSync('snsapiCode', code);
				let spread = that.globalData.spread ? that.globalData.spread : 0;
				Auth.auth(code, that.$Cache.get('SPREAD'))
					.then(res => {
						uni.setStorageSync('snRouter', decodeURIComponent(decodeURIComponent(option.query
							.back_url)));
						if (res.type === 'register') {
							this.$Cache.set('snsapiKey', res.key);
						}
						if (res.type === 'login') {
							this.$store.commit('LOGIN', {
								token: res.token
							});
							this.$store.commit("SETUID", res.uid);
							location.replace(decodeURIComponent(decodeURIComponent(option.query.back_url)));
						}
					})
					.catch(error => {
						if (!this.$Cache.has('snsapiKey')) {
							if (location.pathname.indexOf('/pages/users/wechat_login/index') === -1) {
								Auth.oAuth(snsapiBase, option.query.back_url);
							}
						}
					});
			} else {
				if (!this.$Cache.has('snsapiKey')) {
					if (location.pathname.indexOf('/pages/users/wechat_login/index') === -1) {
						Auth.oAuth(snsapiBase, urlData);
					}
				}
			}
		} else {
			if (option.query.back_url) {
				location.replace(uni.getStorageSync('snRouter'));
			}
		}
		// #endif

		// #ifdef MP
		// 小程序静默授权
		if (!this.$store.getters.isLogin && !this.globalData.tokenIsExist) {
			Routine.getCode().then(code => {
					Routine.authUserInfo(code)
				})
				.catch(res => {
					uni.hideLoading();
				});
		}
		// #endif
		// #ifdef MP-WEIXIN
		// 缓存订阅消息模板ID，供下单/支付等场景调起订阅授权（SubscribeMessage.js从storage读取）
		this.cacheSubscribeTempIds();
		// #endif
		// 主题变色：统一使用绿色主题 theme3
		getTheme().then(resP => {
			that.globalData.theme = 'theme3'
			that.$Cache.set('theme', that.globalData.theme);
			// #ifdef H5
			window.document.documentElement.setAttribute('data-theme', that.globalData.theme);
			// #endif
		})

	},
	async mounted() {
		if (this.$store.getters.isLogin) {
			if (!this.$Cache.get('USER_INFO')) {
				await this.$store.dispatch('USERINFO');
			}
			this.ensureCidUploaded();
		}
	},
	methods: {
		// #ifdef MP-WEIXIN
		cacheSubscribeTempIds() {
			['beforePay', 'afterPay', 'createBargain', 'pink'].forEach(type => {
				getTemlIds({
					type: type
				}).then(res => {
					if (res.data) {
						let arr = [...new Set(res.data.map(item => item.tempId).filter(id => !!id))];
						uni.setStorageSync('tempID' + type, arr);
					}
				});
			});
		},
		// #endif
		ensureCidUploaded() {
			const cid = uni.getStorageSync("cid");
			if (!cid || !this.$store.getters.isLogin) { return; }
			const token = this.$store.state.app.token;
			uni.request({
				url: `${HTTP_REQUEST_URL}/login/addDevice`,
				method: 'POST',
				header: { [TOKENNAME]: token, 'content-type': 'application/json' },
				data: { deviceCode: cid },
				success: (res) => { uni.setStorageSync("lastUploadCid", cid); },
				fail: () => {}
			});
		},
		handlePush(res) {
			try {
				const data = res.data || {};
				const payload = data.payload ? JSON.parse(data.payload) : {};
				const type = payload.type || '';
				const title = data.title || payload.title || '';
				const content = data.content || payload.content || '';
				const payloadData = payload.data ? JSON.parse(payload.data) : {};
			if (res.type === 'receive') {
				uni.$emit('pushMessageReceived', { type, payloadData });
				let showToast = true;
				if (type === 'cs_message') {
					const pages = getCurrentPages();
					const cur = pages.length > 0 ? pages[pages.length - 1].route : '';
					if (cur === 'pages/users/cs_chat/index') { showToast = false; }
					setTimeout(() => { markCsRead().catch(() => {}); }, 1000);
				}
				if (showToast && content) {
					uni.showToast({ title: content, icon: 'none', duration: 2000 });
				}
				this.updateMsgBadge();
				return;
			}
				if (content) {
					uni.showToast({ title: content, icon: 'none', duration: 2000 });
				}
				if (type === 'interact') {
					setTimeout(() => {
						uni.switchTab({ url: '/pages/message/index' });
					}, 500);
				} else if (type === 'system') {
					if (payloadData.msgType === 'kefu') {
						setTimeout(() => {
							uni.switchTab({ url: '/pages/message/index' });
						}, 500);
					} else if (payloadData.msgType === 'kefu_user_msg') {
						setTimeout(() => {
							uni.navigateTo({
								url: '/pages/users/kefu_list/index',
								fail: () => { uni.switchTab({ url: '/pages/message/index' }); }
							});
						}, 500);
					} else if (payloadData.orderId) {
						setTimeout(() => {
							uni.navigateTo({ url: '/pages/order/orderDetail?orderId=' + payloadData.orderId });
						}, 500);
					} else {
						setTimeout(() => {
							uni.switchTab({ url: '/pages/message/index' });
						}, 500);
					}
			} else if (type === 'cs_message') {
				setTimeout(() => {
					uni.navigateTo({
						url: '/pages/users/cs_chat/index',
						fail: () => { uni.switchTab({ url: '/pages/message/index' }); }
					});
				}, 500);
			} else if (type === 'campaign') {
				setTimeout(() => {
					uni.switchTab({ url: '/pages/message/index' });
				}, 500);
			}
			this.updateMsgBadge();
		} catch(e) {
			console.error('处理推送消息失败', e);
		}
		},
	updateMsgBadge() {
		if (!this.$store.getters.isLogin) {
			// #ifndef MP-WEIXIN
			uni.removeTabBarBadge({ index: 2 });
			// #endif
			// #ifdef MP-WEIXIN
			uni.setStorageSync('MSG_BADGE_TOTAL', 0);
			uni.$emit('msgBadge', 0);
			// #endif
			// #ifdef APP-PLUS
			plus.runtime.setBadgeNumber(0);
			// #endif
			return;
		}
		getCntMsg().then(res => {
			const total = (res.data && res.data.total) ? res.data.total : 0;
			// #ifndef MP-WEIXIN
			if (total > 0) {
				uni.setTabBarBadge({ index: 2, text: total > 99 ? '99+' : String(total) });
			} else {
				uni.removeTabBarBadge({ index: 2 });
			}
			// #endif
			// #ifdef MP-WEIXIN
			uni.setStorageSync('MSG_BADGE_TOTAL', total);
			uni.$emit('msgBadge', total);
			// #endif
			// #ifdef APP-PLUS
			plus.runtime.setBadgeNumber(total);
			// #endif
		}).catch(() => {});
	},
			//获取首次授权配置
			getFirstAgree() {
				console.log("isAgreePrivacy", plus.runtime.isAgreePrivacy());
				// andriod隐私弹框使用manifast.json配置设置androidPrivacy.json；ios使用自定义
				const isAgreePriviacy = plus.runtime.isAgreePrivacy();
				// 判断用户是否同意隐私协议
				if (isAgreePriviacy) {
					this.checkGuide();
				} else {
					const platform = uni.getSystemInfoSync().platform;
					if (platform === "ios") {
						const isFirstOpen = uni.getStorageSync('isFirstOpen') || '';
						if (isFirstOpen && isFirstOpen === 'agree') {} else if (isFirstOpen && isFirstOpen === 'onAgree') {
							// 如果未同意授权则跳转到极简模式页
							uni.redirectTo({
								url: '/pages/activeList/cxgList?type=1'
							});
						} else {
							// 如果是首次且未同意授权则跳转到授权提示页
							uni.redirectTo({
								url: '/pages/agreePage/agreePage'
							});
						}
					} else {
						// android未同意授权则跳转到极简模式页
						uni.redirectTo({
							url: '/pages/activeList/cxgList?type=1'
						});
					}
				}


			},
			//获取登录配置
			getLoginConfig() {
				loginConfigApi().then(res => {
					let data = res.data;
					//公众号登录方式(单选),1微信授权，2手机号登录
					this.globalData.publicLoginType = data.publicLoginType;
					this.$Cache.set('publicLoginType', data.publicLoginType);
					//小程序手机号校验类型（多选）1微信小程序验证 2短信验证
					this.globalData.routinePhoneVerification = data.routinePhoneVerification;
					//公司名称
					this.globalData.companyName = data.siteName || '欢迎你';
					uni.setStorageSync('companyName', data.siteName);
					//登录页logo
					this.globalData.mobileLoginLogo = data.mobileLoginLogo;
					uni.setStorageSync('mobileLoginLogo', data.mobileLoginLogo);
					//版权title
					uni.setNavigationBarTitle({
						title: data.siteName
					});
				})
			},
			// #ifdef APP-PLUS
			checkGuide() {
				// 思路： 检测是否有启动缓存，如果没有，就是第一次启动，第一次启动就去 启动介绍页面
				var launchFlag = uni.getStorageSync('launchFlag');
				if (!launchFlag) { //没有缓存进入启动页引导页
					uni.redirectTo({
						url: '/pages/guide/guide',
						success() {
							this.showGuidePage = false;
						}
					});
				}
			},
			// #endif



		},
		onShow: function() {
			// #ifdef APP-PLUS
			const token = this.$Cache.get('token');
			if (token) {
				uni.getPushClientId({
					success: (res) => {
						const oldCid = uni.getStorageSync("cid");
						if (oldCid && oldCid !== res.cid) {
							uni.removeStorageSync("lastUploadCid");
						}
						if (res.cid) {
							uni.setStorageSync("cid", res.cid);
							uploadDeviceCode(res.cid).catch(() => {});
						}
					},
					fail: () => {
						const cid = uni.getStorageSync("cid");
						if (cid) { uploadDeviceCode(cid).catch(() => {}); }
					}
				});
			}
			// #endif
			// #ifdef H5
			uni.getSystemInfo({
				success(e) {
					if (e.windowWidth > 430 && !window.top.isPC && !/iOS|Android/i.test(e.system)) {
					}
				}
			})
			// #endif
			this.updateMsgBadge();
		},
		onHide: function() {},
		onExit: function() {
			// #ifdef APP-PLUS
			unregisterRequestPermissionTipsListener(null)
			// #endif

		}
	}
</script>
<style lang="scss">
	/* #ifndef APP-NVUE */
	@import url("@/plugin/animate/animate.min.css");
	@import 'static/css/base.css';
	@import 'static/iconfont/iconfont.css';
	@import 'static/css/guildford.css';
	@import 'static/css/style.scss';
	@import 'static/css/unocss.css';
	@import 'static/fonts/font.css';




	view {
		box-sizing: border-box;
	}

	.bg-color-red {
		background-color: #E93323;
	}

	.syspadding {
		padding-top: var(--status-bar-height);
	}

	.flex {
		display: flex;
	}

	.ctb-ph {
		width: 100%;
		height: 100rpx;
		height: calc(100rpx + constant(safe-area-inset-bottom));
		height: calc(100rpx + env(safe-area-inset-bottom));
	}

	.uni-scroll-view::-webkit-scrollbar {
		/* 隐藏滚动条，但依旧具备可以滚动的功能 */
		display: none
	}

	/* App端(vue3)不支持 scroll-view 自定义 refresher 插槽，只能用内置下拉刷新；此处将内置图标的默认绿色覆盖为主题色 */
	.uni-scroll-view-refresh__icon {
		fill: #111111 !important;
	}

	.uni-scroll-view-refresh__spinner > circle {
		color: #111111 !important;
	}

	/* 粗门风全局工具类：大圆角白卡 / 胶囊主按钮(荧光绿底深色字) / 荧光笔划重点 / 大圆角上叠面板 */
	.q-card {
		background: #ffffff;
		border-radius: 32rpx;
	}

	.q-pill {
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 999rpx;
		background: #1FFD91;
		color: #111111;
		font-weight: 600;
	}

	.q-pill:active {
		background: #04E07C;
	}

	.q-marker {
		background-image: linear-gradient(180deg, rgba(0, 0, 0, 0) 58%, #1FFD91 58%, #1FFD91 96%, rgba(0, 0, 0, 0) 96%);
	}

	.q-sheet {
		background: #ffffff;
		border-radius: 32rpx 32rpx 0 0;
	}

	::-webkit-scrollbar {
		width: 0;
		height: 0;
		color: transparent;
	}

	/* #endif */
	/* 条件编译，仅在H5平台生效 */
	// #ifdef H5
	body::-webkit-scrollbar,
	html::-webkit-scrollbar {
		display: none;
	}

	// #endif
</style>
